import axios from 'axios';
import { OACData } from '../model/oac-data';

async function getOACDay(assetId: string, startDay?: string, endDay?: string): Promise<OACData[]> {
  const params = new URLSearchParams();
  if (startDay) params.append('startDay', startDay);
  if (endDay) params.append('endDay', endDay);

  const res = await axios.get(`/api/petro-pipeline/oac/${assetId}?${params.toString()}`);
  return res.data?.content ?? [];
}

async function getOACData(
  gasDay: string,
  cycle: string,
  page = 0,
  pageSize = 10,
): Promise<OACData[]> {
  const res = await axios.get(
    `/api/petro-pipeline/oac/${gasDay}/${cycle}?page=${page}&pageSize=${pageSize}`,
  );
  return res.data?.content ?? [];
}

async function getCycles(): Promise<{ _id: string }[]> {
  const res = await axios.get(`/api/petro-pipeline/oac/cycle`);
  return res.data.content;
}

const api = {
  getOACDay,
  getOACData,
  getCycles,
};

export default api;
